import React from "react";
import { Card } from "semantic-ui-react";
import { getWarningMessage, isNonExistentChannel } from "../../../lib/aframeboxlookup/UtilMethods";
import Constants from "../../../lib/aframeboxlookup/Constants";

const { SortBoxDivertReason } = Constants;

const Warning = ({ warning }) => {
  let warningCard = void 0;

  if (warning.divertReason === SortBoxDivertReason.UNFILLED_QUANTITY) {
    warningCard = QuantityWarning(warning);
  } else if (warning.divertReason === SortBoxDivertReason.WEIGHT) {
    warningCard = WeightWarning(warning);
  } else if (!warning.header && warning.divertReason ) {
    warningCard = LineDivertWarning(warning);
  } else if(warning.alarmMessage){
    warningCard = WarehouseAlarm(warning);
    return WarehouseAlarm(warning);
  }
  else if (!warning.divertReason){ 
    warningCard = TextWarning(warning);
  }
  return (
    <Card className="warning-card">
      <Card.Content>
        <Card.Header>{(warning.divertReason != null) ? getWarningMessage(warning.divertReason): null}</Card.Header>
        {warningCard}
      </Card.Content>
    </Card>
  );
};

const TextWarning = (textWarning) => {
  return (
    <Card.Description className="warning-description">
      {textWarning}
    </Card.Description>
  );
};

const LineDivertWarning = ({ channel, skuID }) => {
  return (
    <Card.Description className="warning-description">
      Kanal: {isNonExistentChannel(channel) ? "(saknas)" : channel } SkuID: {skuID}
    </Card.Description>
  );
};

const WeightWarning = ({ estimatedWeight, weight }) => {
  let message = "";
  const weightSign = weight > estimatedWeight ? "+" : "-";

  message = `Avvikelse: ${weightSign}${Math.abs(
    weight - estimatedWeight
  )} ${message}g Estimerad vikt: ${estimatedWeight}g Invägd vikt: ${weight}g`;

  return <Card.Description className="warning-description">{message}</Card.Description>;
};

const QuantityWarning = ({ channel, pickedQuantity, quantity, skuID, shelfNumber, stock }) => {
  return (
    <Card.Description className="warning-description">
      SKU: {skuID} Kanal: {channel}. {pickedQuantity} av {quantity} plockade. HYLLA: {shelfNumber}{" "}
      Lager: {stock.stockQuantity}
    </Card.Description>
  );
};

const WarehouseAlarm = ({alarmMessage}) => {
  return (
    <Card className="warning-card warehouse-alarm ">
        <Card.Content>
          <Card.Header>Larm i Logistiken</Card.Header>
            <Card.Description className="warning-description blink_me">    
            <p>Larm finns för ordern som hör till den här lådan:</p> 
            {alarmMessage} 
          </Card.Description>
        </Card.Content>
      </Card>    
  );
};


export default Warning;
